export class SelectAllCheckbox extends HTMLElement {
    constructor() {
        super()
        this._handle_input = this._handle_input.bind(this)
    }
    connectedCallback() {
        document.addEventListener('input', this._handle_input)
        this._require_selector()
        this.render()

        const wrapped = this._require_wrapped()
        wrapped.onclick = e => {
            const state = this._get_state()

            for (const c of this._iter_controlled()) {
                if (state == 'checked') c.checked = false
                if (state == 'indeterminate') c.checked = true
                if (state == 'unchecked') c.checked = true
            }

            this.render()
        }
    }
    disconnectedCallback() {
        document.removeEventListener('input', this._handle_input)
    }
    _require_selector() {
        const s = this.getAttribute('selector')
        if (!s) throw new Error(`${this.tagName} element requires a non-empty "selector" attribute`)
        return s
    }
    _require_wrapped() {
        const wrapped = this.querySelector('input[type=checkbox]')
        if (!wrapped || !(wrapped instanceof HTMLInputElement)) throw new Error(`${this.tagName} must wrap an <input type=checkbox>`)
        return wrapped
    }
    *_iter_controlled() {
        for (const input of document.querySelectorAll(this._require_selector())) {
            if (input instanceof HTMLInputElement) yield input
        }
    }
    _get_state() {
        const checkboxes = Array.from(this._iter_controlled())
        const has_checked = checkboxes.some(c => c.checked)
        const has_unchecked = checkboxes.some(c => !c.checked)

        if (has_checked && has_unchecked) return 'indeterminate'
        if (has_checked) return 'checked'
        return 'unchecked'
    }
    _handle_input(event: Event) {
        if (!(event.target instanceof HTMLInputElement)) return
        const selector = this._require_selector()
        if (!event.target.matches(selector)) return
        this.render()
    }
    render() {
        const wrapped = this._require_wrapped()
        const state = this._get_state()

        wrapped.checked = state == 'checked'
        wrapped.indeterminate = state == 'indeterminate'
    }

}
customElements.define('qnc-select-all-checkbox', SelectAllCheckbox)
